import Axios from "axios";
import config from "../config";
import { i18n } from "@/plugins/i18n";
//import { async } from 'q';
//import { async } from 'q';
const qs = require("querystring");

function setError(error) {
  if (error.response.status === 401) {
    localStorage.removeItem("userName");
    localStorage.removeItem("accessToken");
    window.location.href = "/";
  }
  if (error.response.status === 400) {
    /* eslint-disable */
    console.log("error : ", {
      status: error.response.status,
      statusText: error.response.statusText,
      message: error.response.data,
    });
    let errorStr = i18n.t("error_400");
    alert(errorStr + " - " + error.response.data);
  }
}

export default {
  GET_DASHBOARD_CMR: async (context, payload) => {
    context.state.loading = true;
    try {
      const response = await Axios.post(
        config.apiBaseUrl + "api/cmr/dashboard-list",
        qs.stringify(payload),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      if (response.status === 200) {
        context.commit("SET_DASHBOARD_CMR", response.data.data);
        context.commit("SET_DASHBOARD_CMR_TOTAL", response.data.total);
      }
      context.state.loading = false;
    } catch (error) {
      context.state.loading = false;
      setError(error);
    }
  },
  GET_CMR: async (context, payload) => {
    context.state.loading = true;
    await Axios.post(
      config.apiBaseUrl + "api/cmr/list",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          context.commit("SET_CMR", response.data.data);
          context.commit("SET_CMR_TOTAL", response.data.total);
        }
        context.state.loading = false;
      })
      .catch(function(error) {
        context.state.loading = false;
        setError(error);
      });
  },
  GET_PDF: async (context, payload) => {
    await Axios.get(config.apiBaseUrl + "api/cmr/pdf?cmr_id=" + payload, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then(function(response) {
        if (response.status === 200) {
          let linkSource = "data:application/pdf;base64," + response.data.pdf;
          let downloadLink = document.createElement("a");
          let fileName = response.data.name;

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
        context.state.loading = false;
      })
      .catch(function(error) {
        context.state.loading = false;
        setError(error);
      });
  },
  GET_USERS: async (context, payload) => {
    context.state.loading = true;
    await Axios.post(
      config.apiBaseUrl + "api/employee/list",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          context.commit("SET_USERS", response.data.data);
          context.commit("SET_USERS_TOTAL", response.data.total);
        }
        context.state.loading = false;
      })
      .catch(function(error) {
        context.state.loading = false;
        setError(error);
      });
  },
  GET_ROLES: async (context, payload) => {
    context.state.loading = true;
    await Axios.post(
      config.apiBaseUrl + "api/role/list",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          context.commit("SET_ROLES", response.data.data);
          context.commit("SET_ROLES_TOTAL", response.data.total);
        }
        context.state.loading = false;
      })
      .catch(function(error) {
        context.state.loading = false;
        setError(error);
      });
  },
  GET_ORGANIZATION: async (context, payload) => {
    context.state.loading = true;
    await Axios.post(
      config.apiBaseUrl + "api/organization/list",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          context.commit("SET_ORGANIZATIONS", response.data.data);
          context.commit("SET_ORGANIZATIONS_TOTAL", response.data.total);
        }
        context.state.loading = false;
      })
      .catch(function(error) {
        context.state.loading = false;
        setError(error);
      });
  },
  SET_ORGANIZATIONS: async (
    { state, dispatch },
    { payloadCreate, payloadUpdate }
  ) => {
    state.loading = true;
    return Axios.post(
      config.apiBaseUrl + "api/organization/create",
      qs.stringify(payloadCreate),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          dispatch("GET_ORGANIZATION", payloadUpdate);
        }
        state.loading = false;
        return response;
      })
      .catch((err) => {
        state.loading = false;
        setError(err);
      });
  },
  UPDATE_ORGANIZATIONS: async (
    { state, dispatch },
    { payloadUpdateForm, payloadUpdate }
  ) => {
    state.loading = true;
    return Axios.post(
      config.apiBaseUrl + "api/organization/edit",
      qs.stringify(payloadUpdateForm),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          dispatch("GET_ORGANIZATION", payloadUpdate);
        }
        state.loading = false;
        return response;
      })
      .catch((err) => {
        state.loading = false;
        setError(err);
      });
  },
  DELETE_ORGANIZATION: async (
    { state, dispatch },
    { payload, payloadUpdate }
  ) => {
    state.loading = true;
    return Axios.get(
      config.apiBaseUrl + "api/organization/delete?Id=" + payload,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          dispatch("GET_ORGANIZATION", payloadUpdate);
        }
        state.loading = false;
        return response;
      })
      .catch((err) => {
        state.loading = false;
        setError(err);
      });
  },
  CREATE_ROLE: async ({ context, dispatch }, payload) => {
    return Axios.post(
      config.apiBaseUrl + "api/role/create",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_ROLES", {});
        }
        return response;
      })
      .catch(function(error) {
        setError(error);
      });
  },
  EDIT_ROLE: async ({ context, dispatch }, payload) => {
    return Axios.post(
      config.apiBaseUrl + "api/role/edit",
      qs.stringify(payload.data || payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_ROLES", payload.searchParams || {});
        }
        return response;
      })
      .catch(function(error) {
        setError(error);
      });
  },
  DELETE_ROLE: async ({ context, dispatch }, payload) => {
    return Axios.get(config.apiBaseUrl + "api/role/delete?Id=" + payload, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_ROLES", {});
        }
        return response;
      })
      .catch(function(error) {
        setError(error);
      });
  },
  CREATE_USER: ({ context, dispatch }, payload) => {
    return Axios.post(
      config.apiBaseUrl + "api/employee/create",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_USERS", {});
        }
        return response;
      })
      .catch(function(error) {
        setError(error);
        return error;
      });
  },
  EDIT_USER: ({ context, dispatch }, payload) => {
    return Axios.post(
      config.apiBaseUrl + "api/employee/edit",
      qs.stringify(payload.data || payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_USERS", payload.searchParams || {});
        }
        return response;
      })
      .catch(function(error) {
        setError(error);
        return error;
      });
  },
  DELETE_USER: async ({ context, dispatch }, { userId, payload }) => {
    return Axios.get(config.apiBaseUrl + "api/employee/delete?Id=" + userId, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_USERS", payload);
        }
        return response;
      })
      .catch(function(error) {
        setError(error);
      });
  },
  SIGNATURE_SHIPPER: async ({ context, dispatch }, payload) => {
    await Axios.post(
      config.apiBaseUrl + "api/cmr/signature-shipper",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_CMR", {});
        }
      })
      .catch(function(error) {
        setError(error);
      });
  },
  SIGNATURE_RECEIVER: async ({ context, dispatch }, payload) => {
    await Axios.post(
      config.apiBaseUrl + "api/cmr/signature-receiver",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_CMR", {});
        }
      })
      .catch(function(error) {
        setError(error);
      });
  },
  SIGNATURE_DRIVER: async ({ context, dispatch }, payload) => {
    await Axios.post(
      config.apiBaseUrl + "api/cmr/signature-driver",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          dispatch("GET_CMR", {});
        }
      })
      .catch(function(error) {
        setError(error);
      });
  },
  SET_COMMENTS: async (context, payload) => {
    await Axios.post(
      config.apiBaseUrl + "api/cmr/comment",
      qs.stringify(payload),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
        }
      })
      .catch(function(error) {
        setError(error);
      });
  },
  GET_COUNTRIES: async (context) => {
    await Axios.get(config.apiBaseUrl + "api/organization/country-list", {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then(function(response) {
        if (response.status === 200) {
          context.commit("SET_COUNTRIES", response.data);
        }
      })
      .catch(function(error) {
        setError(error);
      });
  },
  SET_LANG: (context, lang) => {
    Axios.get(
      config.apiBaseUrl + `api/employee/set-language?language=${lang}`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then(function(response) {
        if (response.status === 200) {
          context.commit("SET_LANG", lang);
        }
      })
      .catch(function(error) {
        /* eslint-disable */
        console.log(error);
      });
  },
};
